import PropTypes from 'prop-types';
import React from 'react';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';

import Smartcard from '../../../../records/customer/Smartcard';
import KeyGoForm from '../../../../records/customer/KeyGoForm';
import CustomerActions from '../../../../actions/CustomerActions';

import SmartcardPayment from '../../SmartcardPayment';
import FormattedHTMLMessage from '../../../general/FormattedHTMLMessage';
import SmartcardReplacementWarning from '../../../smartcard/SmartcardReplacementWarning';
import KeyGoInformation from '../KeyGoInformation';
import KeyGoNotAvailable from '../KeyGoNotAvailable';
import FeatureFlagStore from '../../../../stores/FeatureFlagStore';
import connectToStores from '../../../../helpers/connectToStores';
import { translate as t } from '../../../../lib/I18n';

function Form(props) {
    const {
        smartcard,
        form,
        validation,
        isReplacementPending,
        formInvalid,
        handleFormChange,
        enableKeyGoMinTopup,
        isSingleStepSmartcardRegistration,
        enableSameAsDeliveryAddress,
        onChangeUseDeliveryAddress,
        hasSmartcardInSingleStep
    } = props;

    if (isReplacementPending) {
        return <SmartcardReplacementWarning />;
    }

    if (!isSingleStepSmartcardRegistration && !smartcard.canLoadProduct()) {
        return (
            <Row>
                <Col xs={ 12 }>
                    <KeyGoInformation><KeyGoNotAvailable smartcard={ smartcard } /></KeyGoInformation>
                </Col>
            </Row>
        );
    }

    return (
        <div>
            {!isSingleStepSmartcardRegistration && <Row>
                <Col xs={ 12 }>
                    <KeyGoInformation enableKeyGoMinTopup={ enableKeyGoMinTopup }/>
                </Col>
            </Row>}
            <Row>
                <Col xs={ 12 }>
                    <div className="margin-top--sm padding-bottom--sm">
                        <h3 className="text-weight--normal keygo-registration__title">
                            <FormattedHTMLMessage
                                message='account.smartcard.keygo.add'
                                keygobrand=
                                    { <FormattedHTMLMessage message='account.smartcard.text.keygo'/> }
                            />
                        </h3>
                        <h4 className="text-weight--normal text-primary">
                            { t(`account.smartcard.keygo.${ enableKeyGoMinTopup ? 'minimumTopup' : 'noTopup' }`) }
                        </h4>
                        <SmartcardPayment
                            form={ form }
                            onChange={ handleFormChange }
                            validation={ validation }
                            visited={ formInvalid }
                            onAddressSelected={ CustomerActions.keyGoFormAddressSelected }
                            collectionLocationRequired={ (!isSingleStepSmartcardRegistration || hasSmartcardInSingleStep) && !smartcard.isAwaitingProduct() }
                            enableSameAsDeliveryAddress={ enableSameAsDeliveryAddress }
                            onChangeUseDeliveryAddress={ onChangeUseDeliveryAddress } />
                    </div>
                </Col>
            </Row>
        </div>
    );
}

Form.propTypes = {
    smartcard: PropTypes.instanceOf(Smartcard).isRequired,
    form: PropTypes.instanceOf(KeyGoForm),
    validation: PropTypes.object,
    isReplacementPending: PropTypes.bool,
    formInvalid: PropTypes.bool,
    handleFormChange: PropTypes.func.isRequired,
    enableKeyGoMinTopup: PropTypes.bool,
    hasSmartcardInSingleStep: PropTypes.bool,
    isSingleStepSmartcardRegistration: PropTypes.bool,
    enableSameAsDeliveryAddress: PropTypes.bool,
    onChangeUseDeliveryAddress: PropTypes.func
};

function getStateFromStores () {
    return {
        enableKeyGoMinTopup: FeatureFlagStore.get('enableKeyGoMinTopup')
    };
}

export default connectToStores([FeatureFlagStore], getStateFromStores)(Form);



// WEBPACK FOOTER //
// ./src/components/account/smartcard/keyGoRegistration/Form.js